var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"WisdomSite-layout"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"content-box"},[_c('iframe',{ref:"stfIframe",attrs:{"src":_vm.iframeUrl,"frameborder":"0","id":"iframePage","width":"100%","height":"100%"},on:{"load":_vm.sendMessage}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }